import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import QS from "query-string";
import { getTokens, updateTokens } from "../modules/join.ducks";
import Loader from '../ui-componets/loader';
import { store } from '../redux/store';


interface IProps {
    getTokens: any
    loginDetails: any
    history: any
}

function SsoLogin(props: IProps) {

    useEffect(() => {
        let str = QS.parse(window.location.search).redirectUrl; 
        let finalString = JSON.stringify(str);
        let ecardID = finalString?.replace(/[^0-9]/g,'');

        if(ecardID){
            localStorage.setItem('ssoecardId', ecardID);
        }

        let redirectUrl = QS.parse(window.location.search).redirectUrl;
        let companyShortName = QS.parse(window.location.search).companyShortName;
        let tk = QS.parse(window.location.search).tk;
        let rt = QS.parse(window.location.search).rt;
        
        if (companyShortName) {
            let ssoData = {
                enabled: true,
                companyShortName
            }
            localStorage.setItem('ssoUser', JSON.stringify(ssoData));

            if(tk && rt) {
                let tokens = {
                    access_token: tk,
                    refresh_token: rt
                };

                store.dispatch(updateTokens(tokens));
            }
            if (redirectUrl) {
                if(redirectUrl.includes("my-account/ecards/ecard")){
                    props.history.push(`/my-account/ecards/ecard/`);
                } else {
                    props.history.push(`/${redirectUrl}`);
                }
            } else {
                props.history.push(`/account`);
            }
        }
    }, []);
    
    return (
        <div>
            <Loader />
        </div>
    );
}

const mapStateToProps = (state: any) => ({
    loginDetails: state.join.loginDetails
});

export default connect(mapStateToProps, { getTokens })(SsoLogin);
